import { GetApiData } from './fetchConfig';

export const useOrganizationRoleTypes = () => GetApiData('organizationroletypes');

